<template>
  <div class="OtherReports">

    <Head :title="$tc('header.back')"
          :lanshow="ActiveName" />
    <!-- <NavBar /> -->
    <h5 class="mianbaoxie">
      <span> 当前地址：</span><span> 首页 </span><span> > 其他类 </span>

    </h5>
    <h3>
      <span style="font-size:6vw">受理范围外的举报渠道</span>
      <i></i>
    </h3>
    <div class="OtherReports-container">
      <!-- 其他类 -->
      <div class="OtherReports-content">
        <ul>
          <li @click="toReportInstructions(item.id)"
              v-for="item in ulList"
              :key="item.id">
            <!-- <svg class="icon">
            <use :xlink:href="item.xLinkHref"></use>
          </svg> -->
            <a :href="item.href">
              <div>
                <span v-html="item.name">
                </span>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'OtherReports',
  props: {},
  data () {
    return {

      jubaoxinxitou: [
        { title: '举报类型' },
        { title: '危害小类' },
        { title: '被举报平台' },
        { title: '举报时间' },
        { title: '举报内容' },
        { title: '举报进度' },
        { title: '查看' }
      ],
      jubaoxinxishen: [
        {
          leixing: '诈骗类',
          xiaolei: '电信',
          beijubaopingtai: '网站网页',
          jubaoshijian: '2022-02-12',
          jubaoneirong: '内容',
          jubaojindu: '进度',
          id: '1'
        },
        {
          leixing: '政治类',
          xiaolei: '喜喜1',
          beijubaopingtai: '喜喜2',
          jubaoshijian: '喜喜4',
          jubaoneirong: '喜喜6',
          jubaojindu: '喜喜7',
          id: '2'
        }
      ],
      isShiBai: true,
      showshibai: false,
      isShow: false,
      show: false,
      sousuobianma: '',
      ulList: [
        {
          id: 1,
          name: '互联网金融借贷',
          href: 'https://jubao.nifa.org.cn/ipnifa'
        },
        {
          id: 2,
          name: '网络违法犯罪行为',
          href: 'http://cyberpolice.mps.gov.cn/wfjb/'
        },
        { id: 3, name: '网络交易纠纷', href: 'http://www.12315.cn' },
        {
          id: 4,
          name: '网络虚假违法广告',
          href: 'http://www.12315.cn'
        },
        {
          id: 5,
          name: '网络敲诈删帖',
          href: 'http://cyberpolice.mps.gov.cn/wfjb/'
        },
        { id: 6, name: '邮件、电话骚扰', href: 'https://www.12321.cn' },
        { id: 7, name: '知识产权侵权', href: 'http://www.12315.cn' },
        {
          id: 8,
          name: '盗版侵权',
          href: 'http://www.shdf.gov.cn/shdf/channels/740.html'
        },
        {
          id: 9,
          name: '假媒体、假记者',
          href: 'http://www.shdf.gov.cn/shdf/channels/740.html'
        },
        {
          id: 10,
          name: '涉黑涉恶违法犯罪',
          href: 'http://www.12337.gov.cn/'
        },
        {
          id: 11,
          name: '网络音乐/网络表演/<br />网络动漫等网络文化<br />市场经营活动',
          href: 'http://jbts.mct.gov.cn'
        },
        {
          id: 12,
          name: '电信用户服务',
          href: 'https://yhssglxt.miit.gov.cn/web/'
        }
      ],
      lists: [
        {
          id: 1,
          name: 'admin',
          time: '2022.02.02 13:23',
          pingtai: '网信办',
          statue: '已完结'
        },
        {
          id: 2,
          name: '张三',
          time: '2022.02.02 13:23',
          pingtai: '网信办',
          statue:
            '经过排查，已经通知相关网站整改，请及时关注整改反馈，感谢您的耐心等待！'
        },
        {
          id: 1,
          name: '里斯',
          time: '2022.02.02 13:23',
          pingtai: '网信办',
          statue: '已收到您的举报，处理中'
        }
      ]
    }
  },
  created () {
    this.setShowLoading(false)
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    toReportInstructions (id) { }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  watch: {},
  components: {}
}
</script>
<style lang="scss" scoped>
.OtherReports {
  h3 {
    position: relative;
    text-align: center;
    margin-top: 5vw;
    margin-bottom: 4vw;
    i {
      position: absolute;
      top: 9vw;
      left: 48vw;
      padding-left: 5vw;
      border-bottom: 1vw solid #0852c8;
    }
  }
}
.OtherReports-container {
  box-sizing: border-box;
  // padding: 3vw;
  padding-top: 5.33vw;
}

.OtherReports-content {
  margin-bottom: 8vw;
  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    li {
      width: 44.93vw;
      height: 26.66vw;

      // border: 1vw solid #002fa8;
      margin: 0vw 1.5vw 3vw;
      // text-align: center;
      a {
        div {
          width: 44.93vw;
          height: 26.66vw;
          display: flex;
          justify-content: center;
          align-items: center;
          // margin: 1vw;
          //   padding: 3vw 2vw;
          //   background-color: rgb(207, 139, 139);
          border: 0.6vw solid #dadada;
          font-size: 4vw;
          color: #333333;
          font-weight: 700;
        }
      }
      &:nth-child(11) a div {
        // background-color: #fff;
        font-size: 3.5vw;
      }
    }
  }
}
.popup-chaxun {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.popup-chaxun > div {
  margin: 12vw 3vw;
  font-size: 4vw;
  text-align: center;
  .chaxun-title {
    position: absolute;
    top: 5vw;
    left: 4vw;
  }
  .biaoge {
    margin-top: 4vw;
    border-top: 0.5vw solid #000;
  }
  tr {
    border-left: 0.5vw solid #000;

    td {
      padding: 0.5vw;
      border-right: 0.5vw solid #000;
      border-bottom: 0.5vw solid #000;
      &:nth-child(1) {
        border-left: 0.5vw solid #000;
      }
    }
  }
}
.popup-huifu {
  box-sizing: border-box;
  //   display: flex;
  //   justify-content: space-between;
}
.huifu-title {
  font-size: 5.5vw;
  margin-top: 4vw;
  padding-left: 4vw;
  padding-bottom: 7vw;
}
.popup-chaxunshibai {
  width: 80%;
}
.popup-chaxunshibai > div {
  margin: 12vw 3vw;
  font-size: 4vw;
  text-align: center;
  .chaxun-title {
    position: absolute;
    top: 5vw;
    left: 4vw;
  }
  .chaxun-content {
    padding-top: 10vw;
  }
}
</style>
